import { filter } from 'lodash/fp';

/**
 *  This util filters product ids with excess-<number> in the name.
 *  Legacy products with co-pay aren’t sold on the sales site anymore, so they are not factored into this filter.
 *
 * @param {object} param - An object.
 * @param {string} param.hospitalExcess -  Excess amount to filter for ids for.
 * @param {string[]} param.productIds -  A list of products ids which will be filtered.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const filterIdsByExcess = ({ hospitalExcess, productIds }) =>
  filter((productId: string) => {
    const excessAmount = productId.match(/excess-(\d+)/)?.[1];
    return hospitalExcess === excessAmount;
  }, productIds);

export default filterIdsByExcess;
